import { NNEvidenceInvalid } from "@/api/nn-evidence";
import { RequiredAsterisk } from "@/components/form/required-asterisk";
import { H4 } from "@/components/ui/typography";

interface NNEvidenceTableValidationsProps {
  rfsInvalids?: NNEvidenceInvalid[];
}

export default function NNEvidenceTableValidations(
  props: NNEvidenceTableValidationsProps,
) {
  const { rfsInvalids } = props;

  const getHouseNumber = (result: string) => {
    const match = /House number (\S+)/.exec(result);
    return match ? match[1].trim() : "-";
  };

  return (
    <>
      <span className="text-sm font-bold italic text-red-500">
        <RequiredAsterisk />
        please resubmit with the correct document!
      </span>

      <H4>APD Validation Result</H4>
      <div className="overflow-x-auto">
        <table className="w-full table-auto border">
          <thead className="bg-slate-50">
            <tr>
              <th className="p-4 text-left text-sm font-medium">No</th>
              <th className="p-4 text-left text-sm font-medium">
                Error Message
              </th>
              <th className="p-4 text-left text-sm font-medium">
                House Number
              </th>
              <th className="p-4 text-left text-sm font-medium">Latitude</th>
              <th className="p-4 text-left text-sm font-medium">Longitude</th>
            </tr>
          </thead>
          <tbody>
            {rfsInvalids?.map((rfsInvalid, index: number) => (
              <tr key={rfsInvalid.id} className="border-y">
                <td className="p-4 text-center text-sm">{index + 1}</td>
                <td className="p-4 text-left text-sm">{rfsInvalid.result}</td>
                <td className="p-4 text-left text-sm">
                  {getHouseNumber(rfsInvalid.result)}
                </td>
                <td className="p-4 text-left text-sm">
                  {rfsInvalid.nnEvidence.rfs.trackerdataApd.latitude}
                </td>
                <td className="p-4 text-left text-sm">
                  {rfsInvalid.nnEvidence.rfs.trackerdataApd.longitude}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
